let breakpointCompact = 1024;
// let breakpointTablet = 900; // utilize isTablet
// let breakpointMobile = 600;

// components
const initLoadingBar = (stage) => {
	const loadingBar = document.querySelector('.global-loading-bar');
	const action =
		loadingBar.style.opacity == 1 && stage != 'done' ? 'move' : stage;

	switch (action) {
		case 'start':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				(window.innerWidth * (Math.floor(Math.random() * 6) + 1)) / 10 + 'px';
			break;

		case 'move':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				loadingBar.getBoundingClientRect().width * 1.15 + 'px';
			break;

		case 'done':
			loadingBar.style.width = window.innerWidth + 'px';

			setTimeout(function () {
				loadingBar.style.opacity = 0;
			}, 400);

			setTimeout(function () {
				loadingBar.style.width = 0;
			}, 800);
			break;
	}
};

const initVimeoIframe = () => {
	document.querySelectorAll('[data-vimeo-src]').forEach((iframe) => {
		let observer = new IntersectionObserver(
			(entries) => {
				let target = entries[0].target;

				if (entries[0].isIntersecting) {
					// if video hasn't been loaded, replace src and reframe
					if (!target.hasAttribute('src')) {
						target.src = target.dataset.vimeoSrc;

						if (target.classList.contains('is-reframe')) {
							reframe(
								`[data-vimeo-src="${target.dataset.vimeoSrc}"]`,
								'video-reframe'
							);
						}
					}

					// get play status
					let player = new Vimeo.Player(target);
					if (target.src.includes('background=1') && player) {
						player.on('loaded', () => {
							player.play();
						});

						player.on('play', () => {
							target
								.closest('.video-section')
								.querySelector('.video-thumbnail').style.opacity = 0;
							target
								.closest('.video-section')
								.querySelector('.video-thumbnail').style.visibility = 'hidden';
						});
					}
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: [0, 1],
			}
		);

		observer.observe(iframe);
	});
};

const initMarquee = () => {
	const marquees = document.querySelectorAll('.marquee');

	marquees.forEach((marquee) => {
		setTimeout(() => {
			// block content must be greater the window's innerWidth
			const marqueeContent = marquee.querySelectorAll('.marquee-content');
			const marqueeBlockWidth = marqueeContent[0].clientWidth;

			const factor = Math.ceil(innerWidth / marqueeBlockWidth);
			const marqueeHtml = marqueeContent[0].innerHTML;
			const pixelPerSecond = 150;
			const speed =
				((marqueeBlockWidth * factor) / pixelPerSecond) *
				(marquee.dataset.speedFactor || 1);

			marqueeContent.forEach((block, index) => {
				// override default speed if specified?
				block.style.animationDuration = `${parseInt(speed)}s`;

				// should we replicate content to fill the window's innerWidth?
				if (isFinite(factor)) {
					for (i = 0; i < factor; i++) {
						// if so, repeat block content
						block.insertAdjacentHTML('beforeend', marqueeHtml);
					}
				}

				// prevent tab focus on content
				const marqueeChildren = block.children;
				for (let index = 0; index < marqueeChildren.length; index++) {
					const element = marqueeChildren[index];
					element.setAttribute('aria-hidden', true);
				}
				block.querySelectorAll('a').forEach((a) => {
					a.tabIndex = -1;
				});
			});
		}, 1);
	});
};

const initAccordions = () => {
	const toggleAccordion = (accordion, closeSiblings) => {
		const accordionContent = accordion.querySelector('.accordion-content');
		const accordionBtn = accordion.querySelector('.accordion-button');

		if (closeSiblings) {
			getSiblings(accordion).forEach((item) => {
				if (item.classList.contains('is-expanded')) {
					toggleAccordion(item, false);
				}
			});
		}

		accordion.classList.toggle('is-expanded');

		if (accordion.classList.contains('is-expanded')) {
			accordionBtn.setAttribute('aria-expanded', true);
			accordionContent.setAttribute('aria-hidden', false);
			accordionContent.style.height = `${
				accordionContent.querySelector('.content-interior').clientHeight
			}px`;
		} else {
			accordionBtn.setAttribute('aria-expanded', false);
			accordionContent.setAttribute('aria-hidden', true);
			accordionContent.style.height = '0px';
		}
	};

	on('button', 'click', '.js-toggle-accordion', (e) => {
		let accordion = e.target.closest('.comp-accordion');
		toggleAccordion(
			accordion,
			accordion.classList.contains('is-close-siblings')
		);
	});
};

const initTextFlow = () => {
	let textFlow = document.getElementsByClassName('text-flow');

	Array.from(textFlow).forEach((item) => {
		let textPath = item.querySelector('textPath');
		let path = document.querySelector(textPath.getAttribute('href'));
		let pathLength = path.getTotalLength();
		let offset = item.dataset.offset ? parseInt(item.dataset.offset) : 0;

		// set initial offset on page load
		textPath.setAttribute(
			'startOffset',
			offset - pathLength + window.innerHeight / 4
		);

		const textFlowScroll = () => {
			requestAnimationFrame(function () {
				let rect = item.getBoundingClientRect();
				let scrollPercent = rect.y / window.innerHeight;

				textPath.setAttribute(
					'startOffset',
					offset -
						parseInt((scrollPercent / 2) * pathLength) +
						window.innerHeight / 4
				);
			});
		};

		window.addEventListener('scroll', textFlowScroll);
	});
};

const initLottie = () => {
	let lottie = document.getElementsByClassName('lottie');
	let isFiring = false;

	Array.from(lottie).forEach((item) => {
		const lottieScroll = () => {
			if (
				window.scrollY + window.innerHeight * 0.8 > getOffset(item).top &&
				!item.classList.contains('animate')
			) {
				if (item.closest('.global-footer')) {
					isFiring = true;

					if (isFiring && !item.classList.contains('animate', 'is-reverse')) {
						item.classList.add('animate');
						setTimeout(
							() => {
								item.classList.add('is-reverse');
							},
							isMobile ? 4000 : isTablet ? 6000 : 8000
						);

						item.classList.contains('animate', 'is-reverse')
							? setTimeout(
									() => {
										isFiring = false;
										item.classList.remove('animate', 'is-reverse');
									},
									isMobile ? 8000 : isTablet ? 12000 : 16000
							  )
							: '';
					} else {
						item.classList.remove('animate', 'is-reverse');
					}
				} else {
					item.classList.add('animate');
				}
			}
		};

		window.addEventListener('scroll', lottieScroll);
	});
};

const initFlickity = () => {
	const flickitySlider = document.querySelectorAll('[data-flickity-options]');

	const flickitySliderTrigger = () => {
		flickitySlider.forEach((el) => {
			let flickity = new Flickity(
				el,
				JSON.parse(el.dataset.flickityOptions.replace(/'/g, '"').trim())
			);
			let childrenWidth = Object.values(
				el.querySelector('.flickity-slider').childNodes
			).reduce(
				(total, i) =>
					i.offsetWidth
						? total +
						  i.offsetWidth +
						  parseInt(window.getComputedStyle(i).marginLeft) +
						  parseInt(window.getComputedStyle(i).marginRight)
						: total,
				0
			);

			if (
				// if total children width is lesser than slider width
				el.getBoundingClientRect().width >= childrenWidth ||
				// if flickity slider has breakpoint set, and window is greater than breakpoint
				(el.dataset.flickityBreakpoint &&
					window.innerWidth > parseInt(el.dataset.flickityBreakpoint))
			) {
				// destroy flickity
				flickity.destroy();

				setTimeout(() => {
					el.querySelectorAll('[style*="left:"]').forEach((item) => {
						item.style.setProperty('left', 'unset');
					});
				}, 100);
			} else {
				// avoid click on drag: https://github.com/metafizzy/flickity/issues/838
				flickity.on('dragStart', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'none')
					)
				);

				flickity.on('dragEnd', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'all')
					)
				);
			}

			flickity.on('change', function () {
				if (
					flickity.selectedElement.closest('[data-flickity-sync]') &&
					!flickity.selectedElement
						.closest('[data-flickity-options]')
						.hasAttribute('data-flickity-sync-target')
				) {
					let targetSlide = flickity.selectedElement
						.closest('[data-flickity-sync]')
						.querySelector('[data-flickity-sync-target]');

					let targetSlideDots = targetSlide.querySelectorAll(
						'.flickity-page-dots .dot'
					);

					targetSlideDots.forEach((dot, i) => {
						if (i == flickity.selectedElement.dataset.flickityTrigger) {
							dot.click();
						}
					});
				}
			});
		});
	};

	flickitySliderTrigger();
	window.addEventListener('resize', flickitySliderTrigger);

	// swipe fix for IOS
	var touchingCarousel = false;
	var touchStartCoords;

	document.body.addEventListener('touchstart', function (e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function (e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) {
				e.preventDefault();
			}
		},
		{
			passive: false,
		}
	);
};

const initItemQuantity = () => {
	on('body', 'click', '[data-quantity-trigger]', (e) => {
		let target = e.target.dataset.quantityTrigger
			? e.target
			: e.target.closest('[data-quantity-trigger]');
		let itemQuantity = target.closest('.item-quantity');
		let quantityInput = itemQuantity.querySelector('input[name="quantity"]');

		let updatedValue =
			parseInt(quantityInput.value) +
			(target.dataset.quantityTrigger == 'increase'
				? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
					? 1
					: 0
				: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
				? -1
				: 0);

		quantityInput.value = target
			.closest('.item-quantity ')
			.classList.contains('has-leading-zero')
			? formatLeadingZero(updatedValue)
			: updatedValue;
	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach((item) => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"],
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', determineHasValue);
			input.addEventListener('blur', determineHasValue);
		}
	});
};

// global elements and pages

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach((item) => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == window.location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
		}
	});

	document.querySelectorAll('[data-page-transition]').forEach((item) => {
		item.addEventListener('click', (e) => {
			let target = e.target.hasAttribute('data-page-transition')
				? e.target
				: e.target.closest('[data-page-transition]');

			target.blur();

			if (
				target.dataset.pageTransition == 'internal' &&
				!root.classList.contains('key-is-down')
			) {
				e.preventDefault();
				let isAriaExpanded = false;
				if (
					target.closest('[data-dropdown-content-trigger]') &&
					!target
						.closest('[data-dropdown-content-trigger]')
						.classList.contains('is-active') &&
					isAriaExpanded == false
				) {
					// first click is to activate content of .global-header__dropdown__body
					// second click will link to page
					isAriaExpanded = true;

					return false;
				} else {
					root.classList.remove(
						'header-is-bg',
						'is-header-menu-active',
						'is-mobile-menu-active',
						'is-cart-active'
					);
					root.classList.add('is_leaving');
					setTimeout(() => {
						location.href = target.href;
					}, 400);
				}
			} else if (target.dataset.pageTransition == 'scroll') {
				e.preventDefault();
				seamless.elementScrollIntoView(
					document.querySelector(`#${target.href.split('#')[1]}`),
					{
						behavior: 'smooth',
					}
				);
				focusField(document.querySelector(`#${target.href.split('#')[1]}`));
				// console.log(document.activeElement);
			}
		});
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach((item) => {
		let observer = new IntersectionObserver(
			(el) => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');

					if (el[0].target.querySelector('[data-animate="smil"]')) {
						el[0].target
							.querySelector('[data-animate="smil"] animate')
							.beginElement();
					}
				}
			},
			{ threshold: [0.4] }
		); // 0 = page start; 1 = page bottom, items only revealed when in full view

		observer.observe(item);
	});
};
const initHeader = () => {
	// const headerLogo = header.getElementsByClassName('header-logo')[0];
	// const headerLogoWidth = headerLogo.offsetWidth;
	// const headerBg = header.getElementsByClassName('header-bg')[0];

	const headerScroll = () => {
		window.scrollY > 10
			? root.classList.add('header-is-bg')
			: root.classList.remove('header-is-bg');
	};

	headerScroll();
	window.addEventListener('scroll', headerScroll);

	on('body', 'click', '.js-mobile-menu-open', (e) => {
		root.classList.add('is-mobile-menu-active');
	});

	on('body', 'click', '.js-mobile-menu-close', (e) => {
		root.classList.remove('is-mobile-menu-active');
	});

	on('body', 'click', '.js-mobile-search-trigger', (e) => {
		document.querySelector('.js-mobile-search').classList.toggle('is-active');
		const container = document.querySelector(
			'[data-mobile-menu="search-menu"]'
		);
		focusField(container);
	});

	const activateDropdownContent = (target) => {
		const dropdown = target.closest('[data-dropdown]');
		const prevDropdownContent = dropdown.querySelector(
			'[data-dropdown-content].is-active'
		);
		const targetDropdownContent = dropdown.querySelector(
			`[data-dropdown-content="${target.dataset.dropdownContentTrigger}"]`
		);
		dropdown
			.querySelector('[data-dropdown-content-trigger].is-active')
			.classList.remove('is-active');
		prevDropdownContent.classList.remove('is-active');
		prevDropdownContent.setAttribute('aria-hidden', true);

		targetDropdownContent.classList.add('is-active');
		targetDropdownContent.setAttribute('aria-hidden', false);
		target.classList.add('is-active');
	};

	const openMenu = (e) => {
		const target = e.target.closest('[data-dropdown-trigger]');
		const dropdownTriggers = header.querySelectorAll(`[data-dropdown-trigger]`);
		const dropdownMenus = header.querySelectorAll(`[data-dropdown]`);
		const activeDropdown = header.querySelector(
			`[data-dropdown="${target.dataset.dropdownTrigger}"]`
		);

		getSiblings(target).forEach((element) => {
			element.querySelector('button').setAttribute('aria-expanded', false);
		});

		dropdownTriggers.forEach((trigger) => {
			trigger.classList.remove('is-active');
		});

		dropdownMenus.forEach((dropdown) => {
			dropdown.classList.remove('is-active');
			dropdown.style.maxHeight = '0px';
			dropdown.setAttribute('aria-hidden', true);
		});

		root.classList.add('is-header-menu-active');
		target.classList.add('is-active');
		target.querySelector('button').setAttribute('aria-expanded', true);
		activeDropdown.classList.add('is-active');
		activeDropdown.setAttribute('aria-hidden', false);
		activeDropdown.style.maxHeight = `${
			activeDropdown.querySelector('.js-dropdown-menu').clientHeight
		}px`;

		const container = header.querySelector(
			`[data-dropdown="${target.dataset.dropdownTrigger}"]`
		);
		container ? focusField(container) : '';
	};

	const closeMenu = (e) => {
		let trigger;

		root.classList.remove('is-header-menu-active');
		document
			.querySelectorAll('[data-dropdown-trigger] button')
			.forEach((button) => {
				button.setAttribute('aria-expanded', false);
			});

		if (header.querySelector('[data-dropdown].is-active')) {
			trigger = header.querySelector('[data-dropdown].is-active');
			const container = document.querySelector(
				`[data-dropdown-trigger="${trigger.dataset.dropdown}"]`
			);

			trigger.style.maxHeight = '0px';
			trigger.setAttribute('aria-hidden', true);
			trigger.classList.remove('is-active');

			// refocus on trigger when menu is closed
			focusField(container);
		}

		if (header.querySelector('[data-dropdown-trigger].is-active')) {
			header
				.querySelector('[data-dropdown-trigger].is-active')
				.classList.remove('is-active');
		}

		// revert dropdown menu to default state
		const firstDropdownMenuItem = document.querySelector(
			'[data-dropdown-content-trigger]'
		);
		activateDropdownContent(firstDropdownMenuItem);
	};

	on('body', 'click', '[data-dropdown-trigger]', (e) => {
		let target = e.target.closest('[data-dropdown-trigger]');

		target.classList.contains('is-active') ? closeMenu(e) : openMenu(e);
	});

	on('body', 'click', '[data-dropdown-content-trigger]', (e) => {
		// first click is to activate content of .global-header__dropdown__body
		// second click will link to page
		const target = e.target.dataset.dropdownContentTrigger
			? e.target
			: e.target.closest('[data-dropdown-content-trigger]');

		activateDropdownContent(target);

		target.closest('[data-dropdown]').style.maxHeight = `${
			target.closest('[data-dropdown]').querySelector('.js-dropdown-menu')
				.clientHeight
		}px`;
	});

	on('body', 'keyup', '[data-dropdown-content-trigger]', (e) => {
		// navigate menu with tab key
		if (e.key === 'Tab') {
			const target = e.target.dataset.dropdownContentTrigger
				? e.target
				: e.target.closest('[data-dropdown-content-trigger]');
			// trigger menu content so that it's visible
			target.click();
		}
	});
	on('body', 'keydown', '[data-dropdown-content-trigger]', (e) => {
		if (e.key === 'Enter') {
			// prevent link to page on enter
			e.preventDefault();

			// focus on targeted menu content
			const target = e.target.closest('[data-dropdown-content-trigger]').dataset
				.dropdownContentTrigger;
			const container = document.querySelector(
				`[data-dropdown-content=${target}]`
			);
			focusField(container);
		}
	});

	window.addEventListener('keyup', (e) => {
		if (e.key === 'Escape' || e.key === 'q') {
			root.classList.contains('is-header-menu-active') ? closeMenu() : '';
		}
	});
	on('body', 'click', '.js-dropdown-menu-close', (e) => closeMenu());
};

const initLightbox = () => {
	const openLightbox = (e) => {
		initLoadingBar('start');

		const id = e.target.closest('[data-lightbox-id]').dataset.lightboxId;
		const selectedLightbox = document.querySelector(
			`.comp-lightbox[data-lightbox-id=${id}]`
		);

		root.classList.add('lightbox-is-active');
		selectedLightbox.classList.add('is-active');
		selectedLightbox.setAttribute('aria-hidden', false);
		e.target.closest('.js-lightbox-open').setAttribute('aria-expanded', true);
		focusField(selectedLightbox);

		// init vimeo in lightbox
		if (selectedLightbox.classList.contains('is-video')) {
			const options = {
				background: 1,
				pip: 1,
				title: 1,
				width: innerWidth,
			};

			const selectedIframeContainer =
				selectedLightbox.querySelector('.js-vimeo-video');
			const selectedPlayer = new Vimeo.Player(selectedIframeContainer, options);

			setTimeout(() => {
				initLoadingBar('move');
				selectedPlayer.play();
				selectedPlayer.on('play', () => {
					initLoadingBar('done');
				});
			}, 500);
		}
	};

	const closeLightbox = (e) => {
		let activeLightbox = e.target.closest('.comp-lightbox');
		let activeProductImageSelector = document.querySelector(
			`.js-lightbox-open[data-lightbox-id=${activeLightbox.dataset.lightboxId}]`
		);

		root.classList.remove('lightbox-is-active');
		e.target.closest('.comp-lightbox').classList.remove('is-active');
		e.target.closest('.comp-lightbox').setAttribute('aria-hidden', true);

		activeProductImageSelector.setAttribute('aria-expanded', false);
		// refocus on selector
		activeProductImageSelector.focus();

		// pause video if any
		if (e.target.closest('.comp-lightbox').classList.contains('is-video')) {
			if (!e.target.closest('.comp-lightbox').querySelector('iframe')) {
				return false;
			}
			const player = new Vimeo.Player(
				e.target.closest('.comp-lightbox').querySelector('iframe')
			);

			player.pause();
		}
	};

	on('body', 'click', '.js-lightbox-open', (e) => {
		openLightbox(e);
	});

	on('body', 'click', '.js-lightbox-close', (e) => {
		closeLightbox(e);
	});

	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' || e.key === 'q') {
			root.classList.contains('lightbox-is-active')
				? document.querySelectorAll('.js-lightbox-close').forEach((element) => {
						element.click();
				  })
				: '';
		}
	});
};

const initCart = () => {
	const cart = document.querySelector('.global-minicart');
	// cart visibility
	const cartClose = () => {
		root.classList.remove('is-cart-active');
		history.pushState(null, null, ' ');
		cart.setAttribute('aria-hidden', true);
		cart.tabIndex = -1;
		// focus back to cart trigger
		document.querySelector('.js-minicart-open').focus();
	};

	const cartOpen = () => {
		root.classList.add('is-cart-active');
		root.classList.remove('is-mobile-menu-active');
		history.pushState(null, null, '#cart');
		cart.setAttribute('aria-hidden', false);
		cart.tabIndex = 0;
		focusField(cart);
	};

	document.addEventListener('click', (e) => {
		// open cart trigger
		if (
			e.target &&
			(e.target.classList.contains('js-minicart-open') ||
				e.target.closest('.js-minicart-open'))
		) {
			root.classList.contains('is-cart-active') ? cartClose() : cartOpen();
		}

		// close cart trigger
		if (
			e.target &&
			(e.target.classList.contains('js-minicart-close') ||
				e.target.closest('.js-minicart-close'))
		) {
			cartClose();
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' || e.key === 'q') {
			root.classList.contains('is-cart-active') ? cartClose() : '';
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		cartOpen();
	}

	this.getCartData = (cartItemsEl) => {
		let cartItemsArray = JSON.parse(
			(
				cartItemsEl || document.querySelector('#cart-items-array')
			).dataset.cartItems
				.replace(/'/g, '"')
				.trim()
				.replace(jsonRegex, '')
		);
		let uniqueBundlesArray = [];
		let cartItemCount = 0;

		function countUnique(iterable) {
			return new Set(iterable).size;
		}

		for (let i = 0; i < cartItemsArray.length; i++) {
			if (cartItemsArray[i]._bundleHandle) {
				uniqueBundlesArray.push(cartItemsArray[i]._bundleHandle);
			} else {
				cartItemCount += cartItemsArray[i].quantity;
			}
		}

		cartItemCount = cartItemCount + countUnique(uniqueBundlesArray);

		return {
			items: cartItemsArray,
			count: cartItemCount,
		};
	};

	// updates both cart price and item count
	this.reloadCartData = () => {
		// update item count
		fetch('/cart#cart-items-array')
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				let parser = new DOMParser();
				let dataHtml = parser.parseFromString(data, 'text/html');
				let itemCount = getCartData(
					dataHtml.querySelector('#cart-items-array')
				).count;
				const cart = document.querySelector('.global-minicart');

				document.querySelectorAll('.js-cart-total-items').forEach((item) => {
					item.innerText = `(${itemCount})`;
					item.style.animation = `0.2s fadeIn both`;
				});

				if (itemCount > 0) {
					root.classList.add('cart-has-items');
					cart.setAttribute('aria-hidden', false);
				} else {
					root.classList.remove('cart-has-items');
					cart.setAttribute('aria-hidden', true);
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});

		fetch('/cart.js')
			.then(function (response) {
				return response.json();
			})
			.then((data) => {
				let cartTotalPrice = document.querySelectorAll('.cart-total-price');

				cartTotalPrice.forEach((item) => {
					item.innerText = `$${parseFloat(data.total_price / 100).toFixed(2)}`;
				});
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// updates .comp-cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				let parser = new DOMParser();
				let dataHtml = parser.parseFromString(data, 'text/html');

				// insert the new cart items
				document.querySelectorAll('.comp-cart-items').forEach((item) => {
					item.innerHTML =
						dataHtml.getElementsByClassName('comp-cart-items')[0].innerHTML;
				});

				// initItemQuantity();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		items,
		updateCartTotal = true,
		updateCartItems = true,
		cartOpenDelay = 400
	) => {
		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				items: items,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then((response) => {
				response.json();
			})
			.then((data) => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				cartOpenDelay
					? setTimeout(() => {
							cartOpen();
					  }, cartOpenDelay)
					: '';
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		variantId,
		quantity,
		updateCartTotal = true,
		updateCartItems = false,
		cartOpenDelay = 400
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				id: variantId,
				quantity: quantity,
			}),
		})
			.then((response) => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				cartOpenDelay
					? setTimeout(() => {
							cartOpen();
					  }, cartOpenDelay)
					: '';
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	document.addEventListener('click', (e) => {
		// change quantity trigger
		if (e.target && e.target.dataset.quantityTrigger) {
			let target = e.target;
			let item = target.closest('.item');

			if (item) {
				changeItemQuantity(
					item.dataset.itemId,
					item.querySelector('[name="quantity"]').value,
					true,
					false,
					false
				);
			}
		}

		// remove item trigger
		on('body', 'click', '.item-remove-trigger', (e) => {
			let item = e.target.closest('.item');

			//remove bundle associated items together
			if (
				document.querySelectorAll('.item.is-bundle-item').length > 0 &&
				item.classList.contains('is-bundle-main-item')
			) {
				let removeVariantId = [];
				const bundleItems = document.querySelectorAll('.item.is-bundle-item');

				const removebundleItems = (removeVariantId) => {
					let formData = {
						updates: {},
					};

					let id;
					for (id in removeVariantId) {
						formData['updates'][parseInt(removeVariantId[id])] = 0;
					}

					fetch('/cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(formData),
					})
						.then((response) => response.json())
						.then((data) => {
							reloadCartData();
							reloadCartItems();
							removeVariantId = [];
						})
						.catch((error) => {
							console.error('Error:', error);
						});
				};

				removeVariantId.push(item.dataset.itemId);
				bundleItems.forEach((bundleItem) => {
					removeVariantId.push(bundleItem.dataset.itemId);
				});

				removebundleItems(removeVariantId);
			} else {
				item.remove();
				changeItemQuantity(item.dataset.itemId, 0, true, true, false);
			}
		});

		// quick add item trigger
		if (e.target && e.target.dataset.cartAdd) {
			let target = e.target;

			addItem([
				{
					id: target.dataset.cartAdd,
					quantity: target.dataset.cartAddQuantity || 1,
				},
			]);
		}
	});

	// product form submissions
	document
		.querySelectorAll('form[action="/cart/add"]')
		.forEach((form, index) => {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				let items = [];
				if (e.target.closest('.product-hero').classList.contains('is-bundle')) {
					const bundleItems = e.target
						.closest('.product-hero')
						.querySelectorAll('[data-bundle-id]');

					bundleItems.forEach((item) => {
						items.push({
							id: item.dataset.bundleId,
							quantity: 1,
							properties: {
								_bundleHandle: `bundle-${
									document.querySelector('[data-bundle-id][name="id"]').value
								}`,
								_bundlePrice: `${
									document.querySelector('[data-bundle-price]').dataset
										.bundlePrice
								}`,
							},
						});
					});

					addItem(items);
				} else {

                    var sellingPlanId = '';
                  try {
                      sellingPlanId = form.querySelectorAll('[name="selling_plan"]')[0].value;
                  } catch(e) {}
                  
					addItem([
						{
							id: form.querySelectorAll('[name="id"]')[0].value,
							quantity: form.querySelectorAll('[name="quantity"]')[0].value,
                            selling_plan: sellingPlanId
						},
					]);
				}
			});
		});

	reloadCartData();
};

const initFrontpage = () => {
	// intro section
	const introSection = document.getElementsByClassName('frontpage-intro')[0];
	const introImageImg = introSection
		.getElementsByClassName('intro-image')[0]
		.getElementsByTagName('img')[0];
	const introProductImg = introSection
		.getElementsByClassName('intro-product')[0]
		.getElementsByTagName('img')[0];
	const imageProductXDistance = parseInt(
		introImageImg.getBoundingClientRect().left -
			introProductImg.getBoundingClientRect().left
	);
	const introProductBoundary =
		getOffset(introProductImg)['top'] - window.innerHeight * 0.4 + 80;

	const introScroll = () => {
		if (
			window.scrollY > introProductBoundary &&
			isTablet &&
			!introSection.classList.contains('image-is-in-place')
		) {
			introSection.classList.add('image-is-in-place');
			introImageImg.style.transform = `translateX(-${imageProductXDistance}px)`;
		}
	};

	window.addEventListener('scroll', introScroll);
	introScroll();

	const introVariantTrigger =
		introSection.querySelectorAll('[data-variant-id]');
	const introProductCta = introSection.querySelectorAll('[data-cart-add]')[0];
	const introProductCtaPrice =
		introProductCta.querySelectorAll('.intro-cta-price')[0];

	introVariantTrigger.forEach((item) => {
		item.addEventListener('click', (event) => {
			introVariantTrigger.forEach((el) => {
				el == item
					? el.parentNode.classList.add('active')
					: el.parentNode.classList.remove('active');
			});

			// replace [data-cart-add] button data
			introProductCta.setAttribute('data-cart-add', item.dataset.variantId);
			introProductCtaPrice.innerHTML = item.dataset.variantPrice;
console.log('test here');
			// replace product image
			introProductImg.src = item.dataset.variantImgSrc;

			// remove additional responsive image attributes
			introProductImg.removeAttribute('data-src');
			introProductImg.removeAttribute('data-srcset');
			introProductImg.removeAttribute('srcset');
			introProductImg.removeAttribute('data-sizes');
		});
	});
};

const initProductSingle = () => {
	const heroSection = document.getElementsByClassName('product-hero')[0];
	const heroVariantTrigger = heroSection.querySelectorAll('[data-variant-id]');
	const productFormId = heroSection
		.querySelector('.product-form')
		.querySelector('input[name="id"]');
	const allColors = [];

	// activate first accordion
	if (heroSection.querySelector('.content-details .comp-accordion')) {
		heroSection
			.querySelector('.content-details .comp-accordion .js-toggle-accordion')
			.click();
	}

	const findVariantImage = (selectedColor) => {
		let count = 0;
		heroSection
			.querySelectorAll('.product-image-selector [data-color]')
			.forEach((element) => {
				const imageColor = formatHandleize(element.dataset.color);
				if (imageColor.includes(selectedColor)) {
					// show the matched one
					element.classList.remove('is-hidden');
					element.setAttribute('data-real-index', count);
					element.setAttribute('aria-label', `Switch to image ${count}`);
					element.setAttribute('aria-hidden', false);
					count == 0 ? element.classList.add('is-active') : '';

					count++;
				} else if (
					!allColors.some((color) => imageColor.includes(color)) ||
					!imageColor
				) {
					// show the one that doesn't match any of the color
					element.classList.remove('is-hidden');
					element.setAttribute('data-real-index', count);
					element.setAttribute('aria-label', `Switch to image ${count}`);
					element.setAttribute('aria-hidden', false);

					count++;
				} else {
					// hide the rest
					element.classList.add('is-hidden');
					element.removeAttribute('data-real-index');
					element.setAttribute('aria-hidden', true);
				}
			});

		heroSection.querySelectorAll('[data-real-index]').length == 1
			? heroSection
					.querySelector('.product-image-selector')
					.classList.add('is-hidden')
			: heroSection
					.querySelector('.product-image-selector')
					.classList.remove('is-hidden');

		// init vimeo in .product-image-selector
		heroSection
			.querySelectorAll(
				'.product-image-selector [data-real-index] .video-reframe'
			)
			.forEach((element) => {
				const options = {
					background: 1,
					autoplay: 1,
					muted: 0,
					pip: 1,
					title: 1,
				};
				const player = new Vimeo.Player(element, options);
				player.play();
				player.on('play', function () {
					element.querySelector('iframe').classList.add('css_fadeIn');
				});
			});
	};

	const showSelectedImage = (target) => {
		const index = target.closest('.js-product-image-toggle').dataset.index;

		heroSection
			.querySelectorAll('.product-image-container > .product-image')
			.forEach((img) => {
				img.dataset.index === index
					? img.classList.add('is-active')
					: img.classList.remove('is-active');
			});

		target.closest('.thumbnails').classList.add('is-active');
		getSiblings(target.closest('.thumbnails')).forEach((element) => {
			element.classList.remove('is-active');
		});
	};

	const updateProductImage = (targetSrc) => {
		heroSection
			.querySelectorAll('.product-image-selector img')
			.forEach((img) => {
				img.dataset.srcset.includes(targetSrc)
					? img.closest('.js-product-image-toggle').click()
					: '';
			});
	};

	// show default image
	const defaultVariant = heroSection.querySelector(
		'.product-variant-selector.is-color .active [data-swatch-value]'
	);

	if (!defaultVariant && !heroSection.classList.contains('is-bundle')) {
		setTimeout(() => {
			heroSection.querySelector(
				'.product-image-selector .js-product-image-toggle'
			)
				? heroSection
						.querySelector('.product-image-selector .js-product-image-toggle')
						.click()
				: '';
			heroSection
				.querySelector(
					'.hero-images .product-image-container > .product-image:first-child'
				)
				.classList.add('is-active');
		}, 1);
	}

	const defaultColor = defaultVariant
		? formatHandleize(defaultVariant.dataset.swatchValue)
		: '';

	setTimeout(() => {
		if (!defaultVariant) {
			return false;
		}
		findVariantImage(defaultColor);
		updateProductImage(defaultVariant.dataset.variantImgSrc);
	}, 1);

	on('body', 'click', '.js-product-image-toggle', (e) => {
		showSelectedImage(e.target);
	});

	heroVariantTrigger.forEach((item) => {
		const itemColor = formatHandleize(item.dataset.swatchValue);
		allColors.push(itemColor);

		item.addEventListener('click', (e) => {
			heroVariantTrigger.forEach((el) => {
				item == el
					? el.closest('li').classList.add('active')
					: el.closest('li').classList.remove('active');
			});

			if (item.dataset.variantId) {
				productFormId.value = item.dataset.variantId;
			}

			if (item.dataset.variantUrl) {
				history.replaceState(null, null, item.dataset.variantUrl);
			}

			if (item.dataset.variantPrice) {
				setTimeout(() => {
					let submit = heroSection.querySelector(
						'.product-form [type="submit"]'
					);

					// replace text only when pricing disappears
					if (!submit.innerText.includes(' | ')) {
						let span = document.createElement('span');
						span.classList.add('product-price');

						submit.innerText = `${submit.innerText} | `;
						span.innerHTML = item.dataset.variantPrice;
						submit.appendChild(span);
					}
				}, 251);
			}

			// show matched images when clicking on color option
			const selectedColor = formatHandleize(
				e.target.closest('[data-swatch-value]').dataset.swatchValue
			);
			findVariantImage(selectedColor);

			// update product image
			if (item.dataset.variantImgSrc) {
				updateProductImage(item.dataset.variantImgSrc);
			}
		});
	});

	// size/color selector
	if (!heroSection.classList.contains('is-bundle')) {
		const inputQuantity = heroSection.querySelector('[name="quantity"]');

		on('body', 'click', '.js-variant-option', (e) => {
			let target = e.target.closest('button');

			target.closest('li').classList.add('active');
			getSiblings(target.closest('li')).forEach((el) => {
				el.classList.remove('active');
			});
			const allOptions = heroSection.querySelectorAll('.variant-value');
			let variantSelected = [];

			setTimeout(() => {
				heroSection
					.querySelectorAll(
						'.product-variant-selector li.active [data-swatch-value]'
					)
					.forEach((el) => {
						variantSelected.push(el.dataset.swatchValue);
					});
				let variantSelectedTitle = variantSelected.join(' / '); // e.g. xs / black

				//  find corresponding variant title
				const variantSelectedOption = [...allOptions].find(
					(el) => el.dataset.variantTitle === variantSelectedTitle
				);

				let variantId =
					variantSelectedOption != undefined ? variantSelectedOption.value : '';
				let variantInventory =
					variantSelectedOption != undefined
						? parseInt(variantSelectedOption.dataset.variantInventory)
						: '';
				let variantPrice =
					variantSelectedOption != undefined
						? variantSelectedOption.dataset.variantPrice
						: '';
				let variantUrl =
					variantSelectedOption != undefined
						? variantSelectedOption.dataset.fetchUrl
						: '';

				let submitBtn = heroSection.querySelector(
					'.product-form .btn.add-to-cart'
				);

				if (variantInventory > 0) {
					/* change button state */
                  if(window.location.href.indexOf('travel-bottle') !== -1)
                  {
                    submitBtn.innerHTML = 'Add to cart';
                  }
                  else {
					submitBtn.innerHTML = `Add to cart | ${variantPrice}`;
                  }
                  console.log("testing here");
					submitBtn.disabled = false;

					// update maximum selection
					inputQuantity.setAttribute('max', variantInventory);

					// reset quantity
					inputQuantity.value = inputQuantity
						.closest('.item-quantity')
						.classList.contains('has-leading-zero')
						? '01'
						: '1';
                  $('.klaviyo-bis-trigger').hide();
				} else {
					submitBtn.innerHTML = `Sold out | ${variantPrice}`;
					submitBtn.disabled = true;
                  $('.klaviyo-bis-trigger').show();
				}

				if (variantId) {
					productFormId.value = variantId;
				}

				 if (variantUrl) {
				 	history.pushState(null, null, variantUrl);
				 }
			}, 401);
		});

		//trigger active onload
		heroSection.querySelector('[data-variant-color]')
			? heroSection
					.querySelector(
						'.product-variant-selector li.active [data-variant-color]'
					)
					.click()
			: '';
	}

	const heroContentDetailTrigger = heroSection.querySelectorAll(
		'[data-detail-trigger]'
	);
	const heroContentDetailText = heroSection.querySelectorAll('[data-detail]');

	heroContentDetailTrigger.forEach((item) => {
		item.addEventListener('click', (event) => {
			heroContentDetailTrigger.forEach((trigger) => {
				trigger == item
					? trigger.classList.add('active')
					: trigger.classList.remove('active');
			});

			heroContentDetailText.forEach((text) => {
				text.dataset.detail == item.dataset.detailTrigger
					? text.classList.add('active')
					: text.classList.remove('active');
			});
		});
	});

	function matchDot(target, reverse) {
		let activeTarget = document.querySelector(
			`[${reverse ? 'data-dot-trigger' : 'data-dot-target'}="${
				reverse ? target.dataset.dotTarget : target.dataset.dotTrigger
			}"]`
		);

		getSiblings(target).forEach((el) => {
			el.classList.remove('is-active');
			reverse ? (el.style.backgroundColor = 'transparent') : '';
		});
		getSiblings(activeTarget).forEach((el) => {
			el.classList.remove('is-active');
			!reverse ? (el.style.backgroundColor = 'transparent') : '';
		});

		reverse
			? (target.style.backgroundColor = `${target.dataset.alternativeColor}`)
			: (activeTarget.style.backgroundColor = `${activeTarget.dataset.alternativeColor}`);
		activeTarget.classList.add('is-active');
		target.classList.add('is-active');
	}

	on('body', 'click', '[data-dot-trigger-original]', (e) => {
		let target = e.target.closest('[data-dot-trigger]');
		matchDot(target, false);
	});

	on('body', 'click', '[data-dot-target]', (e) => {
		let target = e.target.closest('[data-dot-target]');

		matchDot(target, true);
	});
};

const initMatch = () => {
	on('body', 'click', '[data-index-trigger]', (e) => {
		if (document.querySelector('.js-match')) {
			let trigger = e.target.closest('[data-index-trigger]');

			let activeTarget = e.target
				.closest('.js-match')
				.querySelector(`[data-index-target="${trigger.dataset.indexTrigger}"]`);

			getSiblings(activeTarget).forEach((item) => {
				item.classList.remove('is-active');
			});
			getSiblings(trigger).forEach((item) => {
				item.classList.remove('is-active');
			});

			trigger.classList.add('is-active');
			activeTarget.classList.add('is-active');
		}
	});
};

const initBlogIndex = () => {
	if (document.querySelector('blog-pagination-next')) {
		let infiniteScroll = new InfiniteScroll('.blog-load-more', {
			path: '.blog-pagination-next',
			append: '.blog-large-container, .blog-compact-container',
			button: '.blog-load-more-trigger',
			scrollThreshold: false,
			history: false,
		});

		infiniteScroll.on('last', function (body, path) {
			let loadMoreTrigger = document.querySelector('.blog-load-more-trigger');

			loadMoreTrigger.style.display = 'block';
			loadMoreTrigger.disabled = true;
			loadMoreTrigger.innerHTML = 'You’ve reached the end';
		});
	}

	let blogSearch = document.querySelector('.blog-search');
	let blogSearchAnchor = document.querySelector('.blog-search-anchor');

	const blogSearchScroll = () => {
		window.scrollY + window.innerHeight + 120 > getOffset(blogSearchAnchor).top
			? blogSearch.classList.add('is-hidden')
			: blogSearch.classList.remove('is-hidden');
	};

	blogSearchScroll();
	window.addEventListener('scroll', blogSearchScroll);
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');
	const gateContent = document.querySelector('.account-gate');
	const resetPasswordTrigger = document.querySelector(
		'.reset-password-trigger'
	);
	const resetPasswordCancel = document.querySelector('.reset-password-cancel');

	if (gateWrapper) {
		resetPasswordTrigger.addEventListener('click', (event) => {
			event.preventDefault();

			// update URL with hash
			history.pushState(null, null, '#recover');

			// assign active state
			root.classList.add('reset-password-active');

			// update wrapper height to fit account reset form
			gateWrapper.style.height =
				document.querySelector('.account-reset').offsetHeight;

			// focus on email field
			document.querySelector('#account-recover-email').focus();
		});

		if (resetPasswordCancel) {
			resetPasswordCancel.addEventListener('click', (event) => {
				event.preventDefault();

				// remove has from URL
				history.pushState(null, null, ' ');

				// remove active state from root
				root.classList.remove('reset-password-active');

				// update wrapper height to fit account reset form
				gateWrapper.style.height = gateContent.offsetHeight;
			});
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			resetPasswordTrigger.click();
		}

		// set initial height
		gateWrapper.style.height = gateContent.offsetHeight;
	}
};

// run functions
initPageTransition();
initPageAnimation();
initVimeoIframe();
initMarquee();
initAccordions();
initTextFlow();
initLottie();
initFlickity();
initItemQuantity();
initFields();
initCart();
initHeader();
initLightbox();
initMatch();

// iframe fit vids
reframe(
	'iframe[src*="vimeo.com"], iframe[src*="youtube.com"]',
	'video-reframe'
);

switch (root.id) {
	case 'frontpage':
		// initFrontpage();
		break;

	case 'product-single':
		initProductSingle();
		break;

	case 'blog-index':
		initBlogIndex();
		break;

	case 'account':
		initAccount();
}
